export default "__VITE_ASSET__D9Kp4Eum__"